// // src/components/Header.js
// import React from 'react';
// import { Link as RouterLink } from 'react-router-dom';
// import { useLocation } from 'react-router-dom';
// import Navbar from './Navbar';
// import './Header.css';

// const Header = ({ title, subtitle, imageUrl, buttonText, secondaryButtonText, showSecondaryButton = true }) => {
//   const location = useLocation();

//   const headerStyle = {
//     marginBottom: location.pathname === '/for-independent-practices' ? '-100px' : '0px',
//   };

//   const titleWidth = {
//     maxWidth: location.pathname === '/for-independent-practices' ? '900px' : '1000px',
//   };

//   return (
//     <header id="header" className="header" style={headerStyle}>
//       <Navbar />
//       <div className="header-content">
//         {/* Left Side - Title, Description, Buttons */}
//         <div className="header-left">
//           <h1 className="header-title" style={titleWidth}>{title}</h1>
//           <p className="header-subtitle">{subtitle}</p>
//           <div className="header-buttons">
//             <RouterLink to="/demo" className="btn primary-btn">
//               {buttonText}
//             </RouterLink>

//             {showSecondaryButton && (
//               <RouterLink to="/about" className="btn secondary-btn">
//                 {secondaryButtonText}
//               </RouterLink>
//             )}
//           </div>
//         </div>

//         {/* Right Side - Image */}
//         <div className="header-right">
//           <img src={imageUrl} alt="Header img" className="header-image" />
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;



// src/components/Header.js
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import './Header.css';

const Header = ({ title, subtitle, imageUrl, buttonText, secondaryButtonText, showSecondaryButton = true }) => {
  const location = useLocation();

  const headerStyle = {
    marginBottom: location.pathname === '/for-independent-practices' ? '-100px' : '0px',
  };

  const titleWidth = {
    maxWidth: location.pathname === '/for-independent-practices' ? '900px' : '1000px',
  };

  return (
    <header id="header" className="header" style={headerStyle}>
      <Navbar />
      <div className="header-content">
        {/* Title Container - Separate */}
        <div className="header-title-container">
          <h1 className="header-title" style={titleWidth}>{title}</h1>
        </div>

        {/* Description + Buttons Container */}
        <div className="header-info">
          <p className="header-subtitle">{subtitle}</p>
          <div className="header-buttons">
            <RouterLink to="/demo" className="btn primary-btn">
              {buttonText}
            </RouterLink>

            {showSecondaryButton && (
              <RouterLink to="/about" className="btn secondary-btn">
                {secondaryButtonText}
              </RouterLink>
            )}
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="header-right">
          <img src={imageUrl} alt="Header img" className="header-image" />
        </div>
      </div>
    </header>
  );
};

export default Header;